












































































































































































































































































































































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  Button,
  Card,
  Checkbox,
  Form,
  FormItem,
  Input,
  Option,
  Select
} from 'element-ui';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import {
  CustomerOrganizationFields,
  CustomerOrganizationInput
} from '@/types/graphql/schemaTypes';
import get from 'lodash/get';
import rules from '@/rules/rules';

import updateCustomerOrg from '@/graphql/mutations/customerOrganization/Update.gql';

// mixins
import countries from '@/mixins/countryOptions';
import scrollError from '@/mixins/scrollError';

import { languageOptions } from '@/constants/languages';

@Component({
  components: {
    UtcDatePicker,
    'el-button': Button,
    'el-card': Card,
    'el-checkbox': Checkbox,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class About extends Mixins(countries, scrollError) {
  @Prop({ required: true })
  private customerOrganization!: CustomerOrganizationFields;

  private customerOrganizationInput: CustomerOrganizationInput | null = null;
  private editing = false;
  private loading = false;

  private readonly rules = rules;
  readonly languageOptions = languageOptions();

  $refs!: {
    companyAboutForm: HTMLFormElement;
  };

  private setInput() {
    this.editing = true;
    this.customerOrganizationInput = {
      address: {
        city: get(this.customerOrganization, 'address.city'),
        line1: get(this.customerOrganization, 'address.line1'),
        line2: get(this.customerOrganization, 'address.line2'),
        prefecture: get(this.customerOrganization, 'address.prefecture')
      },
      countryCode: this.customerOrganization.countryCode,
      normalizedName: this.customerOrganization.normalizedName,
      companyNumber: this.customerOrganization.companyNumber,
      faxNumber: this.customerOrganization.faxNumber,
      id: this.customerOrganization.id,
      isFocus: this.customerOrganization.isFocus,
      language: this.customerOrganization.language,
      memo: this.customerOrganization.memo,
      name: this.customerOrganization.name,
      phoneNumber: this.customerOrganization.phoneNumber,
      postalCode: this.customerOrganization.postalCode,
      shipperConsigneeStandardCode: this.customerOrganization
        .shipperConsigneeStandardCode,
      url: this.customerOrganization.url
    };
  }

  private async submit() {
    this.$refs.companyAboutForm.validate(async(valid: boolean) => {
      if (!valid || !this.customerOrganizationInput) {
        this.scrollError(this.$refs.companyAboutForm);
        return;
      }

      this.loading = true;
      try {
        const response = await this.$apollo.mutate({
          mutation: updateCustomerOrg,
          variables: {
            customerOrganizationArgs: this.customerOrganizationInput
          }
        });

        if (response) {
          this.editing = false;
          this.$emit('refresh');
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.updated'),
            time: 2000
          });
        }
      } catch (error) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      } finally {
        this.loading = false;
      }
    });
  }
}
